import segment from 'src/js/modules/analytics/segment';
import dialogTypes from '../constants/dialog-types';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

function onDialogDisplayed(dialogType) {
  switch (dialogType) {
    case dialogTypes.DIFM_PRIVACY_UPSELL_DIALOG: {
      trackEvent(events.DIFM_PRIVACY_DIALOG_DISPLAYED, {
        dialogId: dialogTypes.DIFM_PRIVACY_UPSELL_DIALOG,
      });

      break;
    }

    case dialogTypes.SUBSCRIPTION_EXPIRED:
    case dialogTypes.B2C_DOMAIN_PURCHASE:
    case dialogTypes.PAYWALL: {
      break;
    }

    default: {
      trackEvent(events.DIALOG_DISPLAYED, {
        dialogId: dialogType,
      });
    }
  }
}

export default onDialogDisplayed;
